<div class="suggestions" *ngIf="!isLoading">
    <ng-container *ngFor="let entry of suggestions | keyvalue">
        <div class="suggestion-group">
            <h3 class="suggestion-group__title">{{ entry.key }}</h3>

            <swiper
                class="suggestion-swiper"
                [slidesPerView]="5"
                [pagination]="{ clickable: true }"
                [breakpoints]="swiperBreakpoints"
                >
                <ng-template swiperSlide *ngFor="let suggestion of entry.value">
                    <app-socio-emotional-skills-test-results-suggestions-card
                        [suggestion]="suggestion"
                        [skillName]="getSkillLevelName(suggestion)"
                        (completed)="onSuggestionCompleted(suggestion)">
                    </app-socio-emotional-skills-test-results-suggestions-card>
                </ng-template>
            </swiper>
        </div>
    </ng-container>
</div>

<div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
</div>